/**
 * 404 Not Found Page
 */

import { Link } from 'react-router-dom'
import Layout from '@components/layout/Layout'

export default function NotFound() {
  return (
    <Layout heroImage="/images/hero/hero-banner.jpg" heroAlt="Page not found">
      <h1>Oops! Page Not Found</h1>
      <div className="about-content">
        <div className="book-grid">
          <div className="card book-card">
            <p>
              Looks like this rocket flew off course! The page you're looking for doesn't exist.
            </p>
            <p>
              <Link to="/" style={{ color: 'var(--link-color)', fontWeight: 600 }}>
                Blast back to the homepage
              </Link>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}
